import { render } from "./bottom-block.vue?vue&type=template&id=cebcfe06&scoped=true"
const script = {}

import "./bottom-block.vue?vue&type=style&index=0&id=cebcfe06&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebcfe06"]])

export default __exports__